
class DynamicYieldAPIClass {
	cache = {};

	preload( selectors, options ) {
		const promise = this.getChoices( selectors, options );

		// Add Promise to Cache, if cacheable.
		const group = options.group;
		if ( group ) {
			[].concat( selectors ).forEach( ( selector ) => {
				this.cache[ group ] ??= {};
				this.cache[ group ][ selector ] = promise;
			} );
		}

		return promise;
	}

	getChoices( selector, options = {} ) {
		const { group, realtimeRules, ...restOptions } = options;
		if ( 'string' === typeof selector ) {
			if ( realtimeRules ) {
				selector = {
					names: [ selector ],
					args: {
						[ selector ]: {
							realtimeRules,
						},
					},
				};
			} else if ( group ) {
				const groupCache = this.cache[ group ] || {};
				const cached = groupCache[ selector ] ?? null;
				if ( cached ) {
					return cached;
				}
			}
		}

		const DY = window.DY || {};
		const context = {
			page: DY.recommendationContext || null,
			...options?.context ?? {},
		};

		return this.choose( {
			...restOptions,
			context,
			selector,
		} );
	}

	async choose( body ) {
		const url = '/index.php?cl=dynamic_yield_api&fnc=choose';
		const promise = fetch( url, {
			'method': 'POST',
			'headers': {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			'body': JSON.stringify( body ),
		} );

		return await promise.then( async( res ) => {
			if ( res.ok ) {
				return await res.json();
			}

			return await Promise.reject( await res.json() );
		} );
	}
}

export default new DynamicYieldAPIClass();
